module.exports = __webpack_public_path__ + "static/media/draggable-container.5e364212.png";